import React from 'react';
import styled from 'styled-components';
import { zIndex } from 'styles/Global/globalStyles';
import TooltipImage from 'assets/Icons/ToolTip/Tooltip.png';

const ClSuccessToolTip = () => {
    return (
        <Layout>
            <TooltipImg src={TooltipImage} alt="성공 기준" />
        </Layout>
    );
};

export default ClSuccessToolTip;

const Layout = styled.div`
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: ${zIndex.floating};
    pointer-events: none;
`;

const TooltipImg = styled.img`
    width: auto;
    height: auto;
    max-width: 185px;
    display: block;
`; 